<div class="input-frame">
	<label class="label" :for="id" :data-text="label">
		<span>{{label}}</span>
	</label>
	<input-color :id="id" :title="title" :value="value" :placeholder="placeholder" @input="handleInput($event)"/>
</div>